import { RightOutlineIcon } from '@carboncopyco/icons';
import {
  CloneBasedIllustration,
  LiveAppIllustration,
  TourFromExistingDemoIllustration,
  TourFromScratchIllustration,
} from '@carboncopyco/illustrations';
import { Button, Modal } from '@carboncopyco/ui';
import { useState } from 'react';
import {
  type Card,
  EntitySelectedCardRadioGroup,
} from '../../EntitySelectCard/EntitySelectedCardRadioGroup';

export interface CreateEntityModalProps {
  open: boolean;
  onClose: () => void;
  handleContinue: (CardId: Card['id']) => void;
  base: 'clone' | 'demo' | 'tour';
  isDemoOverlayDisabled?: boolean;
  isTourFromUrlDisabled?: boolean;
}

const cards = (isDemoOverlayDisabled, isTourFromUrlDisabled) => ({
  demo: [
    {
      illustration: <CloneBasedIllustration />,
      title: 'Cloned app',
      description: 'Add a layer of edits on top of a product clone',
      id: 'clone',
      isNew: false,
      disabled: false,
    },
    {
      illustration: <LiveAppIllustration />,
      title: 'Live app',
      description: 'Add a layer of edits on top of a live product or website',
      id: 'overlay',
      isNew: false,
      disabled: isDemoOverlayDisabled,
    },
  ],
  tour: [
    {
      illustration: <TourFromExistingDemoIllustration />,
      title: 'Existing demo',
      description: 'Create a tour based on an existing demo',
      id: 'demo',
      isNew: false,
      disabled: isTourFromUrlDisabled,
    },
    {
      illustration: <TourFromScratchIllustration />,
      title: 'Live App',
      description: 'Create a tour based on a live product or website',
      id: 'web',
      isNew: true,
      disabled: false,
    },
  ],
});

export const CreateEntityModal = ({
  open,
  onClose,
  handleContinue,
  base,
  isDemoOverlayDisabled,
  isTourFromUrlDisabled,
}: CreateEntityModalProps) => {
  const [selected, setSelected] = useState<Card['id']>(
    base === 'demo' ? 'clone' : isTourFromUrlDisabled ? 'web' : 'demo'
  );

  const modalTitle = (
    <div className="flex items-center">{`Choose a base for your ${base}`}</div>
  );

  return (
    <Modal
      onClose={onClose}
      open={open}
      title={modalTitle}
    >
      <div className="w-ds-lg-modal h-ds-440 flex flex-col">
        <div className="flex justify-center items-center pt-14 pb-18">
          <EntitySelectedCardRadioGroup
            selected={selected}
            onChange={setSelected}
            cards={cards(isDemoOverlayDisabled, isTourFromUrlDisabled)[base]}
          />
        </div>
        <div className="flex justify-end items-center ">
          <Button
            label="Cancel"
            link
            dark
            onClick={onClose}
          />
          <Button
            label="Continue"
            rightIcon={<RightOutlineIcon />}
            onClick={() => {
              handleContinue(selected);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
